import { Tabs } from '@superops/ui-design-system';
// import { isEqual } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledTabContent = styled.div`
  height: fit-content;
  .Superops-Tabs__Wrapper {
    box-shadow: ${(props) =>
      !props?.noShadow && '0px 1px 3px 0px rgba(0, 0, 0, 0.25)'} ;
    margin-bottom: ${(props) => (props.hideMargin ? '0' : '2px')}
    background: #ffffff;
  }
  .Superops-Tabs__Tab--selected {
    font-weight: 500 !important;
  }
  .Superops-Tabs__Tab--selected .Superops-Tabs__Title {
    font-weight: 500 !important;
  }
  .Superops-Tabs__Panel {
    height: calc(100% - 50px);
  }
  .Superops-Tabs__HeightAuto {
    display: flex;
    flex-direction: column;
  }
  .Superops-Tabs__Panel {
    flex-grow: 1;
    overflow: auto;
    height: fit-content !important;
  }
  .tabs-wrap > div {
    height: 100%;
  }
`;

const Tab = styled.div`
  height: 100%;
  overflow: auto;
`;

function TabsContainer(props) {
  const {
    tabs,
    customClassName,
    activeTabIndex,
    hideMargin,
    adjustHeight,
    setActiveVerticalTabIndex,
    noShadow
  } = props;
  const [selected, setSelected] = useState(activeTabIndex || 0);

  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelected(selectedTabIndex);
    if (props.onTabChange) {
      props.onTabChange(selectedTabIndex);
    }
  });

  useEffect(() => {
    if (activeTabIndex !== selected) setSelected(activeTabIndex || 0);
  }, [activeTabIndex]);

  /**
   * Adding id for tabs, since tabs are used from polaris, getting className and setting attributes.
   * @public
   */
  useEffect(() => {
    const element = document.getElementsByClassName('Superops-Tabs__Wrapper');
    if (element && element.length && element[0]) {
      element[0].setAttribute('id', 'ticketTabs');
    }
  }, []);

  const wrapperClassNames = ['flex full-height', props?.wrapperClassNames]
    .filter(Boolean)
    .join(' ');

  return (
    <StyledTabContent
      className={wrapperClassNames}
      hideMargin={hideMargin}
      noShadow={noShadow}
    >
      <div className="fg1 full-width full-height tabs-wrap">
        <Tabs
          tabs={tabs}
          selected={selected}
          fillWhiteBg
          addBottomShadow={!noShadow}
          panelHeight="50px"
          adaptheight
          onSelect={handleTabChange}
          customClassName={customClassName || 'Ticket-Tabs'}
        >
          <Tab
            className="container-tabs"
            title={tabs[selected]?.tooltip}
            id={tabs[selected]?.id}
          >
            {tabs[selected].component}
          </Tab>
        </Tabs>
      </div>
    </StyledTabContent>
  );
}

export default TabsContainer;
